export enum congesTypes {
    LOADING = "LOADING",
    SELECTED_CONGES = "SELECTED_CONGES",
    GET_CONGES_LIST = "GET_CONGES_LIST",
}
  
export default congesTypes;